module.exports = __webpack_public_path__ + "media/images/page/yahoo-wallet-1eb41f6d8e8205c8f7126cb0833861e2.png";